module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp12_4.1608de79.png";